import { observable, action, computed, autorun } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'
import { withCookies, Cookies } from 'react-cookie';
// import moment from 'moment'
// import GolfCourseStore from './GolfCourseStore'
// import DatesStore from './DatesStore'
// import ConfigStore from './ConfigStore'
// import UserStore from './UserStore'

class ModalStore {

  // wheter a modal is open or not
  @observable states = {
    request_information: { open: false, data: {}, onOpen: undefined },
    check_availibility: { open: false, data: {}, onOpen: undefined },
    // cookies: { open: false, data: {}, onOpen: undefined },
    cookies: { open: !(new Cookies()).get('cookies-set'), data: {}, onOpen: undefined },
  }

  @action setState = (slug, state) => {
    this.states[ slug ].open = state

    if( this.states[ slug ].onOpen != undefined)
      this.states[ slug ].onOpen()
  }

  @action setData = (slug, data) => {
    this.states[ slug ].data = data
  }

  @action setOnOpen = (slug, onOpen) => {
    this.states[ slug ].onOpen = onOpen
  }

}

const store = new ModalStore()
export default store



// WEBPACK FOOTER //
// /src/stores/ModalStore.js